import { memo } from "react";
// Needed to use generics through React.memo
export const typedMemo: <T, P>(
  c: T,
  areEquals: (oldProps: P, newProps: P) => boolean
) => T = memo;
export type RecursiveRequired<T> = {
  [P in keyof T]-?: T[P] extends (infer U)[]
    ? RecursiveRequired<U>[]
    : RecursiveRequired<T[P]>;
};
